import React, { Component } from "react"

import {
  HeadingInitial,
  HeadingSecondary,
  Paragraph,
  Section,
  List,
  ListItem,
} from "elements"

class HowSiteWorks extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>How the Site Works</HeadingInitial>

        <Section>
          <List>
            <ListItem>
              For summer camps, recruiting campers is one of the most
              time-consuming, costly, and most important components of their
              off-season activities.
            </ListItem>
            <ListItem>
              The process of finding a camp is equally difficult and frustrating
              to prospective families. It often involves relying of references
              from peers who are basing that recommendation solely on their own
              kids. feedback.
            </ListItem>
            <ListItem>
              The Internet, with its immediacy and interactivity, provides the
              perfect medium for a low-cost solution to the problem of choosing
              a camp. Much more than just another way of connecting camps with
              prospective families, Camps and Campers has the potential to offer
              these services with unprecedented ease.
            </ListItem>
          </List>
          <Paragraph>
            Both camps and camp families submit extensive amounts of information
            with their Camps and Campers registration. This information is
            stored in our database and made available to registered camps and
            families via our search feature. Our site saves everybody time and
            money as they look to fill and find openings at camps because they
            have the information needed to only pursue fruitful paths.
          </Paragraph>
          <Paragraph>
            Camps won’t need to send expensive materials to anonymous requests
            about whom they know very little. Camp families finally have a
            convenient, one-stop, interactive location for finding summer camps
            and getting professional recommendations to help with the process.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>How We Work for Camp Families</HeadingSecondary>
          <Paragraph>
            A prospective family visits our web site and completes a simple but
            comprehensive registration form. Once registered, they can now elect
            to search for camps using a variety of criteria. For example: their
            12 year old son wants a camp in New England that is a coed,
            traditional camp that has baseball and/or water skiing specialities.
            This search may yield a dozen camps. The camps will appear in order
            as ranked by actual camp directors. The family can now browse each
            camp to determine which seems right for him. As they go through the
            list, reviewing camp profiles and browsing their websites, they can
            decide on a few camps that appeal to to them. With a simple click
            they can email their profile to the camps. Using this profile, camps
            can determine if the family is as a good match and how best to
            pursue him.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>How We Work for Camps</HeadingSecondary>
          <Paragraph>
            A camp with camper openings visits our web site, completes a simple
            but comprehensive registration form, and pays a fee for service.
            Once registered, the camp can now elect to search for campers using
            a variety of criteria. For example: the camp has openings for 12
            year old boys. A search for this age group may yield many campers;
            the camp can then narrow the field by specific offerings that cam
            families are looking for. The camp can now browse each candidate to
            determine possible matches. As the camp goes through the list,
            reviewing family profiles, the camp can select the candidates that
            have potential and with a simple click the camp can email these
            candidates with invitations to apply for camp.
          </Paragraph>
        </Section>
      </div>
    )
  }
}

export default HowSiteWorks



// WEBPACK FOOTER //
// ./src/scenes/About/pages/howSiteWorks.js